// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import date from '/util/date.js';
import store from '../../store.js';
import {DATE_FMT} from '../../utils/constants.js';
import {fmt_money} from '../../utils/misc.js';
import {TH, TR, TD, Table} from '../../comp/table';
import {Text} from '../../comp/text';
import './promotions_table.less';

const fmt = d=>date.strftime(DATE_FMT, d);

function Table_header(){
    return <>
      <TH left>ID</TH>
      <TH>Created</TH>
      <TH>Title</TH>
      <TH>Reward</TH>
    </>;
}

function Row({data: d}){
    return <TR className="eapt_row">
      <TD left><Text.s no_wrap mono>{d.id}</Text.s></TD>
      <TD><Text.s mono no_wrap>{fmt(d.date)}</Text.s></TD>
      <TD><Text.s no_wrap>{d.title}</Text.s></TD>
      <TD><Text.s no_wrap>{fmt_money(d.reward)}</Text.s></TD>
    </TR>;
}

const render_row = t=><Row data={t}/>;

export function Promotions_table({className}){
    const [{list}, loading] = store.use_bonuses();
    return <div className={cn('ea_promotions_table', className)}>
      <Text.xxl h2>Promotions</Text.xxl>
      <Table className="eapt_list" header={<Table_header/>} list={list}
        loading={loading} render_row={render_row} id_key="id"/>
    </div>;
}
